import _ from 'lodash';

const fillLocationAddressDetails = ((propertyAddressVm, primaryAddress, translator) => {
    _.set(propertyAddressVm, 'addressLine1.value', primaryAddress.addressLine1);
    _.set(propertyAddressVm, 'addressLine2.value', primaryAddress.addressLine2);
    _.set(propertyAddressVm, 'addressLine3.value', primaryAddress.addressLine3);
    _.set(propertyAddressVm, 'publicID.value', primaryAddress.publicID);

    const county = _.find(propertyAddressVm.county.aspects.availableValues,
        (countyCode) => translator({
            id: `typekey.County_TWIA.${countyCode.code}`,
            defaultMessage: countyCode.code,
        }) === primaryAddress.county);

    const city = _.find(propertyAddressVm.city.aspects.availableValues,
        (cityCode) => (translator({
            id: `typekey.City_TWIA.${cityCode.code}`,
            defaultMessage: cityCode.code,
        }) === primaryAddress.city) 
        && county 
        // 2025-05-15 - Debra Frum - DE19179 - TWIA- Zip code 77642 for Port Arthur gives error
        //   Failure occurred when a single zip code spans more than one city and the name of one of the cities 
        //   is a subset of the other city.
        //   For Example, zip code 77642 spans both the Port Arthur and North Port Arthur cities.
        //   Lookup typelist code belonging to a category instead of comparing typelist code names across typelists.
        // && _.includes(cityCode.code, county.code)); 
        && cityCode.belongsToCategory(county));  

    const zipCode = _.find(propertyAddressVm.postalCode.aspects.availableValues,
        (zip) => (translator({
            id: `typekey.PostalCode_TWIA.${zip.code}`,
            defaultMessage: zip.code,
        }) === primaryAddress.postalCode.substring(0, 5)) 
        && city && county 
        // 2025-05-15 - Debra Frum - DE19179 - TWIA- Zip code 77642 for Port Arthur gives error
        //   Failure occurred when a single zip code spans more than one city and the name of one of the cities 
        //   is a subset of the other city.
        //   For Example, zip code 77642 spans both the Port Arthur and North Port Arthur cities.
        //   Lookup typelist code belonging to a category instead of comparing typelist code names across typelists.
        // && _.includes(zip.code, city.code));
        && city.belongsToCategory(county) 
        && zip.belongsToCategory(city))

    _.set(propertyAddressVm, 'city.value', city);
    _.set(propertyAddressVm, 'county.value', county);
    _.set(propertyAddressVm, 'postalCode.value', zipCode);
    _.set(propertyAddressVm, 'state.value', primaryAddress.state);
    _.set(propertyAddressVm, 'country.value', primaryAddress.country);
    _.set(propertyAddressVm, 'addressType.value', primaryAddress.addressType);
});

const createRequestData = ((submissionVM, reqVal, address, translator) => {
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value')
    
    _.set(reqVal, 'jobNumber.value', jobID);
    _.set(reqVal, 'city.value', translator({
        id: `typekey.City_TWIA.${address.city}`,
        defaultMessage: address.city,
    }));
    _.set(reqVal, 'county.value', translator({
        id: `typekey.County_TWIA.${address.county}`,
        defaultMessage: address.county,
    }));
    _.set(reqVal, 'postalCode.value', translator({
        id: `typekey.PostalCode_TWIA.${address.postalCode}`,
        defaultMessage: address.postalCode,
    }));
    _.set(reqVal, 'state.value', address.state);
    _.set(reqVal, 'country.value', address.country);
});

const fillPrimaryAddressDetails = ((primaryAddressVM, locationAddress, translator) => {
    _.set(primaryAddressVM, 'addressLine1.value', locationAddress.addressLine1);
    _.set(primaryAddressVM, 'addressLine2.value', locationAddress.addressLine2);
    _.set(primaryAddressVM, 'addressLine3.value', locationAddress.addressLine3);
    _.set(primaryAddressVM, 'publicID.value', locationAddress.publicID);

    _.set(primaryAddressVM, 'city.value', translator({
        id: `typekey.City_TWIA.${locationAddress.city}`,
        defaultMessage: locationAddress.city,
    }));
    _.set(primaryAddressVM, 'county.value', translator({
        id: `typekey.County_TWIA.${locationAddress.county}`,
        defaultMessage: locationAddress.county,
    }));
    _.set(primaryAddressVM, 'postalCode.value', translator({
        id: `typekey.PostalCode_TWIA.${locationAddress.postalCode}`,
        defaultMessage: locationAddress.postalCode,
    }));
    _.set(primaryAddressVM, 'state.value', locationAddress.state);
    _.set(primaryAddressVM, 'country.value', locationAddress.country);
    _.set(primaryAddressVM, 'addressType.value', locationAddress.addressType);
});

export default {
    'fillLocationAddressDetails': fillLocationAddressDetails,
    'createRequestData': createRequestData,
    'fillPrimaryAddressDetails': fillPrimaryAddressDetails
}